import React, { useEffect } from "react";
import { ScrollToTop } from "../components/ScrollToTop";

const CookiePolicy = () => {
  useEffect(() => {
    
  }, []);
  return (
    <main class="max-w-4xl mx-auto px-4 py-10 text-gray-800">
      <h1 class="text-3xl font-bold text-center mb-6">Cookie Policy</h1>
      <p class="mb-6 text-sm text-gray-500">Updated at: 2023-06-20</p>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">Definitions and Key Terms</h2>
        <p class="mb-4">
          To help explain things as clearly as possible in this Cookie Policy,
          the following terms are strictly defined:
        </p>
        <ul class="list-disc list-inside space-y-2">
          <li>
            <strong>Cookie:</strong> Small amount of data generated by a website
            and saved by your browser. Used to identify your browser, provide
            analytics, and remember preferences.
          </li>
          <li>
            <strong>Company:</strong> Refers to “Sairah A venture of Soradis
            Group under Soradis Jewellers Private Limited.”
          </li>
          <li>
            <strong>Device:</strong> Any internet-connected device like a phone,
            tablet, or computer.
          </li>
          <li>
            <strong>Personal Data:</strong> Information that identifies or could
            identify a natural person.
          </li>
          <li>
            <strong>Service:</strong> The service provided by the company as
            described in relevant terms or on the website.
          </li>
          <li>
            <strong>Third-party service:</strong> Advertisers, partners, or
            platforms that may interact with the site or its users.
          </li>
          <li>
            <strong>Website:</strong> Refers to{" "}
            <a href="https://sairahjewels.com/" class="text-blue-600 underline">
              https://sairahjewels.com/
            </a>
          </li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">Introduction</h2>
        <p>
          This Cookie Policy explains how “Sairah A venture of Soradis Group
          under Soradis Jewellers Private Limited” and its affiliates use
          cookies and similar technologies to recognize you when you visit our
          website. It also explains what these technologies are, why we use
          them, and how you can control them.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">What is a Cookie?</h2>
        <p>
          A cookie is a small text file stored on your device to identify your
          browser, remember information such as login details or preferences,
          and provide analytics. Cookies are safe and do not execute programs or
          transmit viruses.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">Why Do We Use Cookies?</h2>
        <ul class="list-disc list-inside space-y-2">
          <li>Facilitate the website’s operation and functionality.</li>
          <li>Improve navigation and user experience.</li>
          <li>Provide personalized experiences and relevant content.</li>
          <li>Analyze usage and customize site layout and content.</li>
          <li>Identify marketing prospects and tailor sales strategies.</li>
          <li>Enable targeted advertising based on user behavior.</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">Types of Cookies We Use</h2>
        <p class="mb-4">We use both session and persistent cookies:</p>
        <ul class="list-disc list-inside space-y-2">
          <li>
            <strong>Essential Cookies:</strong> Required for website
            functionality, such as security and accessibility. Disabling them
            may affect site operation.
          </li>
          <li>
            <strong>Marketing Cookies:</strong> Used to identify future
            prospects and personalize interactions.
          </li>
          <li>
            <strong>Analytics & Customization Cookies:</strong> Help understand
            user behavior and marketing effectiveness.
          </li>
          <li>
            <strong>Social Media Cookies:</strong> Enable content sharing, track
            ad conversions, and support remarketing efforts.
          </li>
          <li>
            <strong>Third-party Cookies:</strong> Set by partners and
            advertisers to support analytics and ad targeting. These are not
            controlled by us.
          </li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">Managing Your Cookies</h2>
        <p class="mb-4">
          Most browsers allow you to control cookie settings. Disabling cookies
          may reduce site functionality and personalization. Refer to your
          browser’s help section for guidance:
        </p>
        <ul class="list-disc list-inside space-y-2">
          <li>Google Chrome</li>
          <li>Internet Explorer</li>
          <li>Mozilla Firefox</li>
          <li>Safari (Desktop & Mobile)</li>
          <li>Android Browser</li>
          <li>Opera / Opera Mobile</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">
          Blocking & Disabling Cookies
        </h2>
        <p>
          You can block cookies via your browser settings, but this may impact
          your ability to use certain features. Disabling or blocking cookies
          does not delete them — you must manually remove them from your browser
          settings.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">Changes to This Policy</h2>
        <p>
          We may update this Cookie Policy as our services evolve. We will
          notify users of material changes. Continued use of our website after
          changes implies acceptance of the updated policy.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">Your Consent</h2>
        <p>
          By using our website, registering an account, or making a purchase,
          you consent to this Cookie Policy and its terms.
        </p>
      </section>

      <section>
        <h2 class="text-2xl font-semibold mb-4">Contact Us</h2>
        <ul class="list-disc list-inside">
          <li>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:support@sairahjewels.com"
              class="text-blue-600 underline"
            >
              support@sairahjewels.com
            </a>
          </li>
          <li>
            <strong>Phone:</strong>
            <a href="tel:8828826996" class="text-blue-600 underline">
              {` `}8828826996
            </a>
          </li>
        </ul>
      </section>
    </main>
  );
};

// const Section = ({ title, children }) => (
//   <section className="mb-8">
//     <h2 className="text-2xl font-semibold mb-2">{title}</h2>
//     {children}
//   </section>
// );

export default CookiePolicy;
